import EditIcon from "@material-ui/icons/Edit";
import { Button, Datagrid, DeleteWithConfirmButton, Edit, EditButton, Filter, List, SimpleForm, TextField, TextInput, TopToolbar, useNotify, useRecordContext } from "react-admin";
import { Link } from "react-router-dom";
import { MyDateField } from "../../MyDateField";
import { EpgListingEditToolbar, EpgListingForm, getEpgListingErrorMessage, redirectToEpgEditListing } from "./epg-listing-form";

export const EpgEditListingEdit = (props) => {
  const notify = useNotify();
  const onFailure = (error) => {
    notify(getEpgListingErrorMessage(error), "warning");
  };

  return (
    <Edit {...props} onFailure={onFailure} mutationMode="pessimistic">
      <SimpleForm toolbar={<EpgListingEditToolbar />} redirect={redirectToEpgEditListing}>
        <EpgListingForm />
      </SimpleForm>
    </Edit>
  );
};

const EpgEditListingFilter = (props) => (
  <Filter {...props}>
    <TextInput label="ID" source="programme_id" alwaysOn />
    <TextInput label="Name in TC" source="name_tc" alwaysOn />
  </Filter>
);

const ListActions = () => (
  <TopToolbar>
    <Button component={Link} to="/epg-listing" label="EPG List">
      <EditIcon />
    </Button>
  </TopToolbar>
);

const CustomDelete = () => {
  const record = useRecordContext();

  return (
    <DeleteWithConfirmButton record={record} undoable={false} confirmContent="Are you sure you want to delete this item?" />
  );
};

export const EpgEditListingList = (props) => {
  return (
    <List {...props} actions={<ListActions />} bulkActionButtons={false} filters={<EpgEditListingFilter />} sort={{ field: "created_at", order: "DESC" }}>
      <Datagrid>
        <MyDateField label="Start Time" source="epg_item_event_time" showTimeWithSeconds />
        <TextField label="Original Programme ID" source="original_programme_id" />
        <TextField label="Original Programme Name" source="original_name_tc" />
        <TextField label="Original Episode No." source="original_episode_no" />
        <TextField label="Edited Programme ID" source="replaced_programme_id" />
        <TextField label="Edited Programme Name" source="replaced_name_tc" />
        <TextField label="Edited Episode No." source="replaced_episode_no" />
        <EditButton />
        <CustomDelete />
      </Datagrid>
    </List>
  );
};
